import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewInit, Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { combineLatest, Subscription } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ModalService } from "src/app/modules/modal/services/modal.service";
import { ApiService } from "src/app/services/api/api.service";
import { UpdateTermsAndConditionsCheckboxState } from "src/app/store/actions/termsAndConditions";
import { Logout, MeRequest } from "src/app/store/actions/user";
import {
  selectIsAuthenticated,
  selectRegistrationCompleted,
} from "src/app/store/selectors";
import { IAppState } from "src/app/store/states/app";

@Component({
  selector: "app-terms-and-conditions-popup",
  templateUrl: "./terms-and-conditions-popup.component.html",
  styleUrls: ["./terms-and-conditions-popup.component.scss"],
})
export class TermsAndConditionsPopupComponent implements OnInit, OnDestroy {
  private termsAndConditionsSubscription: Subscription;
  private termsAndConditions;

  private registrationCompleted: boolean;

  constructor(
    private _store: Store<IAppState>,
    private apiService: ApiService,
    private router: Router,
    private modalService: ModalService,
  ) {}

  ngOnInit() {
    this.termsAndConditionsSubscription = this.apiService
      .get("tac")
      .pipe(map((response) => response))
      .subscribe((response) => {
        this.termsAndConditions = response.data.terms_and_conditions;
      });

    combineLatest([
      this._store.select(selectIsAuthenticated),
      this._store.select(selectRegistrationCompleted),
    ]).subscribe(([authenticated, registrationCompleted]) => {
      this.registrationCompleted =
        authenticated && registrationCompleted ? true : false;
    });
  }

  onAcceptTAC() {
    if (this.registrationCompleted) {
      const requestData = new FormData();
      requestData.append("_method", "patch");
      this.apiService
        .post("profile/accept-tac", requestData)
        .pipe(map((response: any) => response))
        .subscribe((response) => {
          this._store.dispatch(new MeRequest({}));
        });
    } else {
      // dispatch true / close popup
      this._store.dispatch(new UpdateTermsAndConditionsCheckboxState(true));
    }
    this.modalService.closePopup();
  }

  onDeclineTAC() {
    if (this.registrationCompleted) {
      this._store.dispatch(new Logout({}));
    } else {
      // dispatch false/ close popup
      this._store.dispatch(new UpdateTermsAndConditionsCheckboxState(false));
    }
    this.modalService.closePopup();
  }

  onCloseModal() {
    if (this.registrationCompleted) {
      this._store.dispatch(new Logout({}));
    }
    this.modalService.closePopup();
  }

  get getMessage() {
    return this.termsAndConditions;
  }

  ngOnDestroy() {
    if (this.termsAndConditionsSubscription) {
      this.termsAndConditionsSubscription.unsubscribe();
    }
  }
}
